// StockAvailabilitySelection.tsx - body-only "Availability" panel (single
// "In stock" checkbox). Header/accordion chrome lives in FilterSelection.
// Mirrors trade's PDF multifilter availability filter.
import React, { ChangeEvent } from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';

interface StockAvailabilitySelectionProps {
  showInStock: boolean;
  onStockChange: (inStockOnly: boolean) => void;
  isLoading?: boolean;
}

const StockAvailabilitySelection: React.FC<StockAvailabilitySelectionProps> = ({
  showInStock,
  onStockChange,
  isLoading = false,
}) => {
  const handleStockCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    onStockChange(event.target.checked);
  };

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={showInStock}
            onChange={handleStockCheckboxChange}
            disabled={isLoading}
          />
        }
        label="In stock"
      />
    </FormGroup>
  );
};

export default StockAvailabilitySelection;
